'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIFullScreen = require('./UIFullScreen');

var _UIFullScreen2 = _interopRequireDefault(_UIFullScreen);

var _UIModalDialog = require('./UIModalDialog');

var _UIModalDialog2 = _interopRequireDefault(_UIModalDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIModal',

  propTypes: _extends({}, _UIModalDialog2.default.propTypes, {
    children: _react.PropTypes.node.isRequired,
    _contextual: _react.PropTypes.bool
  }),

  contextTypes: {
    sandboxed: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIModalDialog2.default.defaultProps, {
      _contextual: false
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        _contextual = _props._contextual,
        rest = _objectWithoutProperties(_props, ['children', '_contextual']);

    var renderedModalDialog = _react2.default.createElement(
      _UIModalDialog2.default,
      _extends({}, rest, { contextual: _contextual }),
      children
    );

    var sandboxed = _contextual || this.context.sandboxed;
    return sandboxed ? renderedModalDialog : _react2.default.createElement(
      _UIFullScreen2.default,
      null,
      renderedModalDialog
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/dialog/UIModal.js
// module id = 317
// module chunks = 0